import { MixPuzzle } from "shared/games/mixpuzzles/types";
import getDefaultMixPuzzleInstrument from "./getDefaultMixPuzzleInstrument";

export default function getDefaultMixPuzzleInstruments(mixPuzzle: MixPuzzle) {
  const instruments: MixPuzzle["instruments"] = {};

  Object.values(mixPuzzle.instruments).forEach(({ id, instrument }) => {
    instruments[instrument] = getDefaultMixPuzzleInstrument(id, instrument);
  });

  return instruments;
}
